import { Component, Input, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DOCUMENT } from '@angular/common';
import { Subscription, Subject } from 'rxjs';

@Component({
  selector: '[modal-re-authenticate-inbox]',
  template: require('./modal-re-authenticate-inbox.component.pug'),
  styles: [require('./modal-re-authenticate-inbox.component.css').toString()],
})
export class ModalReAuthenticateInboxComponent {
  @Input()
  data: any;

  invite_url: string;
  inboxId: string = null;

  sub: Subscription = null;

  public reason: Subject<any>;

  // -------------------------------------------------------------------
  constructor(
    @Inject(DOCUMENT) private document: any,
    private accountService: AccountService,
    private watch: WatchAccountService,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
  ) {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.accountService
    .generateInboxInvite(this.watch.accountId().getValue(), this.inboxId, null, null)
    .subscribe(response => {
      this.invite_url = response['data'].generateInboxInvite.url;
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

  copied = false;

  // -------------------------------------------------------------------
  copyLink(val: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.copied = true;
  }

}
